export default "__VITE_ASSET__3d6984ac__"